import {Component, OnInit, ViewChild, ElementRef, OnDestroy} from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ApiService } from '../../../services/api.service';
import { TemplateService } from '../../../services/template.service';
import { HttpParams } from "@angular/common/http";
import { CONSTANT, SUPPORT_FORMAT } from "../../../services/constant";
import {API_CONSTANT} from "../../../services/api.constant";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.scss'],
  providers: [TemplateService]
})
export class DocumentUploadComponent implements OnInit, OnDestroy {

  objectKeys = Object.keys;
  objectValues = function(obj) {
    // Object.values is not supported in IE11

    if (typeof obj === 'string' || obj instanceof String)
      return [obj];
    else
      return Object.keys(obj).map(e => obj[e]);
  };

  file: File;
  selectedDocumentType: string;
  step = 0;
  isLoading = false;
  is_loading = false;
  event_name = '';
  error_message: any;
  fileList: any[] = [];
  fileDocList: any[] = [];
  fileData: any[] = [];
  isXMLDownloaded: any;
  isPDFDownloaded: any;
  list = [];
  gettingSummary = false;
  upload_status_message = '';
  totalDocument: number;
  totalPayment: number;
  totalVat: number;
  signDocResultPath: string;
  resultCurrentPage = 1;
  date: Date;
  uploadCSVStatusIntervalHandler: any = null;
  taxDataResultCount = 0;
  taxDataResultItemPerPage = 40;
  tax_import_id = 0;
  modal: NgbModalRef;

  loading_all_zip = false;
  cancel_loading_all_zip = false;
  loading_all_zip_message = '';
  allZipCount: number;
  allZipCurrent = 0;
  loading_all_zip_progress: number = 0;
  errorMsgForShow: string = null;

  Namebottomback = '';
  Namebottomtampate = '';

  @ViewChild('fileDoc')
  fileDocInput: ElementRef;

  items = [
    {label: 'เลือกประเภทเอกสาร'},
    {label: 'อัพโหลดไฟล์ CSV'},
    {label: 'สร้างไฟล์'},
    {label: 'ผลลัพธ์'}
  ];

  encodingType = CONSTANT.encodingType;
  encodingSelected = 'UTF-8';
  gettingUploadCSVStatus = false;

  countIsCheckAll = 0;
  isCheckAll = false;

  constructor(private apiService: ApiService,
              private modalService: NgbModal,
              private template: TemplateService,
              private router: Router,
              private translate: TranslateService) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.uploadCSVStatusIntervalHandler != null)
      clearInterval(this.uploadCSVStatusIntervalHandler);

    this.uploadCSVStatusIntervalHandler = null;
  }

  get supportFormat() {
    return SUPPORT_FORMAT.join();
  }

  csvToArray(text) {
    // More info: https://stackoverflow.com/questions/8493195/how-can-i-parse-a-csv-string-with-javascript-which-contains-comma-in-data
    let p = '', row = [''], ret = [row], i = 0, r = 0, s = !0, l;
    for (l of text) {
        if ('"' === l) {
            if (s && l === p) row[i] += l;
            s = !s;
        } else if (',' === l && s) l = row[++i] = '';
        else if ('\n' === l && s) {
            if ('\r' === p) row[i] = row[i].slice(0, -1);
            row = ret[++r] = [l = '']; i = 0;
        } else row[i] += l;
        p = l;
    }
    return ret;
  }

  incomingFile(event?) {
    const files = _.get(event, 'target.files', [this.file]);
    this.file = _.get(event, 'target.files[0]', this.file);
    this.getSummary()
    // if (files.length) {
    //   const csvReader = new FileReader();
    //   csvReader.onload = (e: any) => {
    //     const contents = e.target.result;
    //     this.fileList = this.csvToArray(contents);
    //   };
    //   csvReader.readAsText(files[0], this.encodingSelected);
    // }
  }

  selectEncoding() {
    if (this.file) {
      this.incomingFile();
    }
  }

  nextStep(step) {
    this.step = step;
  }

  getSummary() {
    const document = new FormData();
    document.append('file', this.file);
    document.append('file_type', this.selectedDocumentType);
    document.append('decode_type', (this.encodingSelected === 'UTF-8') ? 'utf-8' : 'CP874');

    this.gettingSummary = true;
    this.apiService.postSummary(document).subscribe(
      (res: any) => {
        this.totalDocument = res.total_document;
        this.totalPayment = res.total_payment;
        this.totalVat = res.vat;
        this.step = 2;

        this.gettingSummary = false;
      },
      (err) => {
        this.error_message = err.error;
        this.step = 3;

        this.gettingSummary = false;
      }
    );
  }

  selectDocumentType(type) {
    this.selectedDocumentType = type;
    this.step = 1;
  }

  generateXML() {
    this.isLoading = true;
    const document = new FormData();
    document.append('rd_document_type', this.selectedDocumentType);
    document.append('csv_file', this.file);
    document.append('decode_type', (this.encodingSelected === 'UTF-8') ? 'utf-8' : 'CP874');
    this.error_message = null;

    this.apiService.uploadCSV(document).subscribe(
      data => {
        data = data || {};
        let background_job_id = data['background_job_id'];
        this.tax_import_id = data['id'];

        this.upload_status_message = '0 %';
        this.gettingUploadCSVStatus = false;
        if (this.uploadCSVStatusIntervalHandler != null)
          clearInterval(this.uploadCSVStatusIntervalHandler);

        this.uploadCSVStatusIntervalHandler = setInterval(() => {
          this.refreshUploadCSVStatus(background_job_id);
        }, 5000);
      },
      error => {
        this.error_message = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
        this.isLoading = false;
        this.step = 3;
      }
    );
  }

  refreshUploadCSVStatus(background_job_id) {
    if (this.gettingUploadCSVStatus)
      return;

    this.gettingUploadCSVStatus = true;
    this.apiService.getBackgroundJobStatus(background_job_id).subscribe(
      data => {
        data = data || {};
        let status = data['status'];
        let progress = data['progress'] || 0;

        this.upload_status_message = '' + progress + ' %';

        if (status == 'success') {
          clearInterval(this.uploadCSVStatusIntervalHandler);
          this.uploadCSVStatusIntervalHandler = null;

          this.upload_status_message = 'กำลังแสดงผลลัพธ์ ...';
          this.resultCurrentPage = 1;
          this.showUploadCSVResult();

        } else if (status == 'failed') {
          clearInterval(this.uploadCSVStatusIntervalHandler);
          this.uploadCSVStatusIntervalHandler = null;

          this.error_message = data['result'];
          if (this.error_message != null && this.error_message.message != null)
            this.error_message = this.error_message.message;
          else if(!this.isFieldError(this.error_message))
            this.error_message = JSON.stringify(this.error_message);

          this.isLoading = false;
          this.step = 3;
        }

        this.gettingUploadCSVStatus = false;
      },
      error => {
        this.gettingUploadCSVStatus = false;
      }
    );
  }

  showUploadCSVResult() {
    const params = new HttpParams().set('page', _.toString(this.resultCurrentPage));

    const data = {
      'tax_import_id': this.tax_import_id
    };

    this.apiService.getTaxDataResult(data, params).subscribe(
      data => {
        data = data || {};
        this.taxDataResultCount = data.count;
        this.list = data.results;
        this.list.forEach(obj => {
          obj.checked = false;
        });
        this.isLoading = false;
        this.step = 3;
      },
      error => {
        this.error_message = 'ข้อมูลได้นำเข้าสู่ระบบเรียบร้อยแล้ว ท่านสามารถดูผลลัพธ์ได้ที่เมนูค้นหาเอกสาร';
        this.isLoading = false;
        this.step = 3;
      }
    );
  }

  sendEmail() {
    this.is_loading = true;
    let idList = this.list.filter(obj =>  obj.checked == true).map(l => l.id);
    const data = {
      'keys' : idList
    };
    this.apiService.sendEmail(data).subscribe(
      res => {
        this.is_loading = false;
        this.step = 0;
      },
      error => {
        this.is_loading = false;
        this.step = 0;
      }
    )
  }

  checkBox(event) {
    this.isCheckAll = false;
    if (event) {
      this.countIsCheckAll++;
    }
    if (!event) {
      this.countIsCheckAll--;
    }
    if (this.list && (this.countIsCheckAll === this.list.length)) {
      this.isCheckAll = true;
    }
  }

  checkAll(event) {
    if (!event) {
      this.countIsCheckAll = 0;
    }
    if (event) {
      this.countIsCheckAll = this.list.length;
    }
    this.list.map(obj => {
      return obj['checked'] = event;
    });
  }

  resetAll() {
    // location.replace('/document/upload');
    this.step = 0;
    this.file = null;
    this.error_message = null;
    this.isLoading = false;
    this.selectedDocumentType = null;
    this.event_name = '';
    this.fileList = [];
    this.fileData = [];
    this.isXMLDownloaded = null;
    this.isPDFDownloaded = null;
    this.list = [];
    this.totalDocument = 0;
    this.totalPayment = 0;
    this.totalVat = 0;
    this.date = null;
  }

  resetSignDoc() {
    this.fileDocList = [];
    this.error_message = null;
    this.isLoading = false;
    this.signDocResultPath = null;
  }

  makeDownloadedAll() {
    // this.apiService.getDownloadableURL(this.fileData).subscribe(
    //   (obj: any) => {
    //     console.log('result', obj);
    //     this.list = obj;
    //   }
    // );

    // _.forEach(this.fileData, (obj) => {
    //   this.apiService.postDownloadFile({id: obj, file_type: 'both'});
    // });
    //console.log('list', this.list);
  }

  // downloadFile(tax_data, type) {
  //   this.apiService.getFileFullPath(API_CONSTANT.BASE_URL + (type == 'xml' ? tax_data.xml_file : tax_data.pdf_file)).subscribe(
  //     (obj) => {
  //       let filename = this.getFileName(tax_data.header_invoice_number) + '.' + type;
  //       this.apiService.createDownloadFile(obj, filename);
  //     },
  //     error => {
  //     }
  //   )
  // }

  previewFile(tax_data) {
    window.open(API_CONSTANT.BASE_URL + tax_data.pdf_file, '_blank')
  }


  preview(tax_data, type) {
    window.open(API_CONSTANT.BASE_URL + (type == 'xml' ? tax_data.xml_file : tax_data.pdf_file), '_blank');
  }
  
  download(type, page_number, page_all_count, index, data_list) {
    this.loading_all_zip = true;

    if (index >= data_list.length && page_number > page_all_count) {
      this.loading_all_zip = false;
      this.loading_all_zip_message = "Download เสร็จสมบูรณ์ (ทั้งหมด " + this.allZipCount + " รายการ)";
      return;
    }

    if (this.cancel_loading_all_zip) {
      return;
    }

    let tax_data = data_list[index];
    this.apiService.getFileFullPath(API_CONSTANT.BASE_URL + (type == 'xml' ? tax_data.xml_file : tax_data.pdf_file)).subscribe(
      (obj) => {
        if (this.cancel_loading_all_zip) {
          return;
        }

        let filename = this.getFileName(tax_data.header_invoice_number) + '.' + type;
        this.apiService.createDownloadFile(obj, filename);
        this.allZipCurrent++;
        this.loading_all_zip_progress = (this.allZipCurrent / this.allZipCount) * 100;
        setTimeout(() => {

          if (index + 1 < data_list.length)
            this.download(type, page_number, page_all_count, index+1, data_list);
          else if (page_number < page_all_count) {
            page_number += 1;
            this.apiService.getTaxDataResult({ 'tax_import_id': this.tax_import_id }, new HttpParams().set('page', "" + page_number)).subscribe(
              data => {
                data = data || {};
                this.download(type, page_number, page_all_count, 0, data.results);
              },
              error => {
                this.loading_all_zip = false;
                this.loading_all_zip_message = "เกิดข้อผิดพลาด โปรดลองอีกครั้ง";
              }
            );
          }
          else {
            this.download(type, page_number+1, page_all_count, 0, []);
          }

        }, 1000);
      },
      error => {
        this.loading_all_zip = false;
        this.loading_all_zip_message = "เกิดข้อผิดพลาด โปรดลองอีกครั้ง";
      }
    );
  }

  downloadAll(type, content) {
    this.apiService.getTaxDataResult({ 'tax_import_id': this.tax_import_id }, new HttpParams().set('page', "1")).subscribe(
      data => {
        data = data || {};
        this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false});
        this.allZipCount = data.count;
        this.cancel_loading_all_zip = false;
        this.download(type, 1, Math.ceil(data.count/40), 0, data.results);
      },
      error => {

      }
    );
  }

  closeDownloadAll() {
    this.modal.close();
    this.cancel_loading_all_zip = true;
    this.loading_all_zip = false;
    this.allZipCurrent = 0;
    this.loading_all_zip_progress = 0;
  }

  //
  // downloadZip() {
  //   this.date = new Date();
  //   const params = new HttpParams().set('list_id', _.toString(_.uniq(this.fileData)));
  //   this.apiService.getZip(params).subscribe(
  //     (obj) => {
  //       let filename = 'documents' + moment().format('YYYY-MM-DD') + '.zip';
  //       this.apiService.createDownloadFile(obj, filename);
  //
  //       this.makeDownloadedAll();
  //     },
  //     error => {
  //     }
  //   )
  // }

  generateDoc() {
    this.isLoading = true;
    this.error_message = null;
    const form = new FormData();
    for (const file of this.fileDocList) {
      form.append('file', file);
    }

    this.apiService.signSignature(form).subscribe(
      blob => {
        this.signDocResultPath = blob
        this.isLoading = false;
      },
      error => {
        this.error_message = this.checkErrorMsg(error);
        this.isLoading = false;
      }
    );
  }

  checkErrorMsg(error) {
    this.errorMsgForShow = this.apiService.getErrorMessage(error);
    if (this.translate.currentLang === 'en') {
      this.error_message = this.errorMsgForShow[0]
    } else {
      this.error_message = this.errorMsgForShow[1]
    }
  }

  downloadSignedDoc() {
    var filename = '';
    if (this.fileDocList.length == 1) {
      let filenameSplit = this.fileDocList[0].name.split('.');
      let extension = filenameSplit.pop();
      filename = filenameSplit.join('.') + '_signed.' + extension;
    } else {
      filename = 'documents_signed.zip';
    }

    this.apiService.createDownloadFile(this.signDocResultPath, filename);
  }

  removeFile() {
    this.file = null;
    this.fileList = [];
  }

  removeDocFile(index: number) {
    this.fileDocList.splice(index, 1);
    if (this.fileDocList.length === 0) {
      this.resetSignDoc();
    }
  }

  getFileName(invoice_number) {
    return invoice_number.replace(/[^-\w.ก-๙]+/g, '_');
  }

  isFieldError(errors: any) {
    return errors != null && errors.length > 0 && errors[0].row;
  }
   getNamebottomback(){
    if(this.translate.currentLang === 'en'){
        this.Namebottomback = 'Back'
    }
    if(this.translate.currentLang ==='th'){
      this.Namebottomback = 'กลับ'
    }
     return this.Namebottomback;
}
  getNamebottomtemplate(){
    if(this.translate.currentLang ==='en'){
      this.Namebottomtampate = 'Create new file';
    }
    if(this.translate.currentLang === 'th'){
      this.Namebottomtampate = 'สร้างเอกสารใหม่';
    }
    return this.Namebottomtampate;
  }
}




// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-upload/document-upload.component.ts